import WarningMessage from "./danger-warning";
import Header from "./header";
import Formik from "./formik";
import Submit from "./submit";
import Footer from "./footer";
import Reset from "./reset";
import Title from "./title";
import Root from "./root";
import Body from "./body";

export const OffcanvasForm = { Root, Header, Body, Formik, Reset, Submit, Footer, Title, WarningMessage };
